"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockUrlLinkProperty = exports.infoBlockUrlLinkPropertyDefinition = void 0;
exports.infoBlockUrlLinkPropertyDefinition = {
    view: {
        label: 'URL',
        hint: 'Please enter a valid URL!',
        style: 'url',
    },
    constraints: [
        {
            name: 'pattern',
            argument: '^https?:\\/\\/(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'info-block-url-link',
};
const isInfoBlockUrlLinkProperty = (prop) => {
    return prop.name === exports.infoBlockUrlLinkPropertyDefinition.name;
};
exports.isInfoBlockUrlLinkProperty = isInfoBlockUrlLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay11cmwtbGluay5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stdXJsLWxpbmsucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxrQ0FBa0MsR0FBRztJQUNoRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSwyQkFBMkI7UUFDakMsS0FBSyxFQUFFLEtBQUs7S0FDYjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsa2VBQWtlO1NBQzdlO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHFCQUFxQjtDQUNJLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==